import type { UpdateCourseDraft200LocalizedSectionsItem } from './updateCourseDraft200LocalizedSectionsItem';

/**
 * 언어별 섹션 정보 매핑
 * @nullable
 */
export type UpdateCourseDraft200LocalizedSections = {[key: string]: UpdateCourseDraft200LocalizedSectionsItem[]} | null;
